import Link from "next/link"
import { Genre } from "src/models/genre/Genre"
import { HashTag } from "src/models/tieup/HashTag"
import CommonLabel from "src/components/common/CommonLabel"
import TieupImg from "./common/TieupImg"
import { SizeType } from "./common/TieupImg/SizeType"

type Props = {
  isTieup?: boolean
  title?: string
  thumbnail?: string
  catchCopy?: string
  genres?: Genre[]
  hashtags?: HashTag[]
  link: string
}

const SearchResultTieupItem: React.FC<Props> = ({
  // isTieup = true,
  thumbnail,
  catchCopy,
  genres,
  hashtags,
  link,
  title,
}) => {
  return (
    <article className="p-searchNovalResult-item">
      <div className="p-searchNovalResult-image">
        <Link href={link}>
          <a className="p-searchNovalResult-image-anchor js-simplified-trigger">
            <TieupImg
              src={thumbnail || "/img/cover.png"}
              alt={title}
              size={SizeType.s}
            />
          </a>
        </Link>
      </div>
      <div className="p-searchNovalResult-detail">
        <p className="p-searchNovalResult-copy">{catchCopy}</p>
        <h2 className="p-searchNovalResult-title">
          <Link href={link}>
            <a className="p-searchNovalResult-title-anchor js-simplified-trigger">
              {title}
            </a>
          </Link>
        </h2>
        {!!genres && (
          <ul className="p-searchNovalResult-genre">
            {genres.map((genre) => (
              <li key={genre.id}>
                <CommonLabel style="tertiary" text={genre.name} />
              </li>
            ))}
          </ul>
        )}
        {!!hashtags && (
          <ul className="p-searchNovalResult-tag p-wordList-secondary">
            {hashtags.map((h) => (
              <li key={h.id}>{h.name}</li>
            ))}
          </ul>
        )}
      </div>
    </article>
  )
}

export default SearchResultTieupItem
